import Vue from "vue";
import moment from "moment";
import { lang } from "@/plugins/vue-i18n";

// possible return values: Today, Yesterday, the days of the week
// returns -1 if date is older than 7 days
Vue.filter("findRelativeDayDifference", date => {
  const newDate = moment(date).startOf("day");
  const todayDate = moment().startOf("day");

  let daydifference = todayDate.diff(newDate, "days");
  
  if(daydifference == 0) {
    return "Today";
  }
  if(daydifference == 1) {
    return "Yesterday";
  }
  if(daydifference > 1 && daydifference < 8) {
    return newDate.locale(lang).format("dddd");
  }
  
  return -1;
});